import moment from "moment";

import { Recall } from "@/Common/Api/Communications/Dto/Recall";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { Guid } from "@/Common/Models/Guid";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class RecallTableItem implements ITableDataSourceItem<Recall> {
    // ItableDataSourceItem implementation
    public Model: Recall;
    public IsSelected: boolean;
    public IsInFocus: boolean;
    public Name: string;

    public Id: string;
    public PatientId: Guid;
    public PatientName: string;
    public PatientFirstName: string;
    public PatientLastName: string;
    public PatientPreferredName: string;
    public DoctorContactId: Guid;
    public ResponsibleProviderName: string;
    public ResponsibleProviderLastName: string;
    public ResponsibleProviderFirstName: string;
    public Description: string;
    public DueDate: Date;
    public DueDateString: string;
    public PriorityLookupId: string;
    public PriorityDisplayString: string;
    public RecallCommunicationStatusLookupId: string;
    public RecallCommunicationStatus: string;
    public RecallCommunicationCount: number;
    public Status: string;

    public static FromRecall(recallResponse: Recall): RecallTableItem {
        const item = new RecallTableItem();
        item.Id = recallResponse.Id;
        item.PatientLastName = recallResponse.PatientLastName;
        item.PatientFirstName = recallResponse.PatientFirstName;
        item.PatientPreferredName = recallResponse.PatientPreferredName;
        item.PatientName = NameHelper.formatFullNameForHasPatientName(item);
        item.PatientId = recallResponse.PatientLinkContactId;
        const employee = cacheStore.GetEmployeeByContactIdOrEmpty(recallResponse.DoctorContactId);
        const clinician = cacheStore.GetCliniciansPersonsByContactId(recallResponse.DoctorContactId);

        item.DoctorContactId = recallResponse.DoctorContactId;
        item.ResponsibleProviderFirstName = employee.FirstName;
        item.ResponsibleProviderLastName = employee.LastName;
        item.ResponsibleProviderName = clinician.Name;

        item.Description = recallResponse.Type;
        item.DueDate = moment(recallResponse.DueDate).toDate();
        item.DueDateString = moment(recallResponse.DueDate).format("YYYY-MM-DD");
        item.PriorityLookupId = recallResponse.PriorityLookupId;
        item.PriorityDisplayString = cacheStore.GetLocalizedValueByLookupId(recallResponse.PriorityLookupId);

        switch (recallResponse.Status) {
            case "COMPLETE":
                item.Status = cacheStore.GetString("CompletedLabel");
                break;

            case "DUE":
                item.Status = cacheStore.GetString("DueLabel");
                break;

            case "PASTDUE":
                item.Status = cacheStore.GetString("PastDueLabel");
                break;

            default:
                item.Status = "";
                break;
        }

        if (recallResponse.RecallCommunications && recallResponse.RecallCommunications.length > 0) {
            item.RecallCommunicationStatusLookupId = recallResponse.RecallCommunications[0].StateLookupId;
            item.RecallCommunicationStatus = cacheStore.GetLocalizedValueByLookupId(item.RecallCommunicationStatusLookupId);
            item.RecallCommunicationCount = recallResponse.RecallCommunications.length;
        }
        else
            item.RecallCommunicationCount = 0;

        item.Model = recallResponse;

        return item;
    }
}

export { RecallTableItem };
